const typography = {
  // Stats labels
  TOTAL_USERS_ALL_TIME: "Total Users (All Time)",
  PAID_USERS: "Paid Users",
  FREE_USERS: "Free Users",
  ENGAGED_USERS: "Engaged Users",
  DELETED_USERS: "Deleted Users",
  IDLE_USERS: "Idle Users",
  SIGNUPS: "Signups",
  // Filter labels
  ALL: "All",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PENDING: "Pending",
  FREE: "Free",
  PREMIUM: "Premium",
  TRIAL: "Trial",
  DATE_RANGE: "Date Range",
};

export default typography;
